import { styled } from '@mui/system';
import { EffectCoverflow, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import 'swiper/css';

function Slider({ data, isMicrosite }) {
  if (!data.length) {
    return null;
  }

  return (
    <SliderContainer className={isMicrosite ? 'slider-container slider-container-microsite' : 'slider-container'}>
      <div className="swiper-button-prev"></div>
      <div className="swiper-button-next"></div>

      <Swiper
        effect={'coverflow'}
        grabCursor={true}
        centeredSlides={true}
        loop={true}
        slidesPerView={'auto'}
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 2.5,
        }}
        pagination={{ el: '.swiper-pagination', clickable: true }}
        navigation={{
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          clickable: true,
        }}
        modules={[EffectCoverflow, Pagination, Navigation]}
        className="swiper_container"
      >
        {data.map((item, index) => (
          <SwiperSlide key={index}>
            <img className="slider-img" src={item.img || item.image} loading="lazy" alt="item image" />
          </SwiperSlide>
        ))}
      </Swiper>
    </SliderContainer>
  );
}

export default Slider;

const SliderContainer = styled('div')(({ theme }) => ({
  width: 'calc(100% + 32px)',
  margin: '0 auto',
  position: 'relative',

  '&.slider-container-microsite': {
    maxWidth: 700,
    margin: '0 auto',
    position: 'relative',
    [`@media (max-width: 450px)`]: {
      width: 'calc(100% + 32px)',
      '& .swiper-button-next': { right: 15 },
      '& .swiper-button-prev': { left: 15 },
    },
    '& .swiper-slide .slider-img': {
      width: 154,
      height: 300,
    },
    '& .swiper-slide': {
      width: 180,
      height: 300,
      position: 'relative',
    },
  },

  '& .swiper-button-prev, & .swiper-button-next': {
    backgroundColor: 'white',
    borderRadius: '50%',
    width: 30,
    height: 30,
    color: 'black',
    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.3)',
    '&:after': {
      fontSize: 18,
    },
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.8)',
    },
  },

  '& .swiper-button-next': { right: 5 },
  '& .swiper-button-prev': { left: 5 },

  '& .swiper_container': {
    padding: '1rem 0',
    position: 'relative',
  },

  '& .swiper-slide': {
    width: 180,
    height: 200,
    position: 'relative',
  },

  '& .swiper-slide .slider-img': {
    width: 150,
    height: 184,
    borderRadius: 10,
    objectFit: 'cover',
  },

  '& .swiper-slide-shadow-left, & .swiper-slide-shadow-right': {
    display: 'none',
  },

  '& .slider-controler': {
    position: 'relative',
    bottom: '2rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .swiper-button-next': {
      left: '58% !important',
      transform: 'translateX(-58%) !important',
    },
  },

  '& .swiper-pagination': {
    position: 'relative',
    width: '15rem !important',
    bottom: '1rem',
    '& .swiper-pagination-bullet': {
      filter: 'drop-shadow(0px 8px 24px rgba(18, 28, 53, 0.1))',
    },
    '& .swiper-pagination-bullet-active': {
      background: 'var(--primary)',
    },
  },
}));
